/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 出血量
 */
export type FindEmsContactBleedingValueEnum =
  (typeof FindEmsContactBleedingValueEnum)[keyof typeof FindEmsContactBleedingValueEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FindEmsContactBleedingValueEnum = {
  MINIMAL: 'MINIMAL',
  LOW: 'LOW',
  MODERATE: 'MODERATE',
  HIGH: 'HIGH',
  UNKNOWN: 'UNKNOWN',
} as const;
